import Vue from 'vue'
import Router from 'vue-router'
import test from '@/components/test'

// 线上商城
import index from '@/components/shoppingMall/index'
import login from '@/components/shoppingMall/login'
import register from '@/components/shoppingMall/register'
import my from '@/components/shoppingMall/my'
import shop from '@/components/shoppingMall/shop'

//官方网站
import home from '@/components/official/home'
import qyjs from '@/components/official/qyjs'
import gywm from '@/components/official/gywm'
import zshz from '@/components/official/zshz'
import sjrz from '@/components/official/sjrz'
import ywms from '@/components/official/ywms'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/ywms',
      name: 'ywms',
      component: ywms
    },
    {
      path: '/sjrz',
      name: 'sjrz',
      component: sjrz
    },
    {
      path: '/zshz',
      name: 'zshz',
      component: zshz
    },
    {
      path: '/gywm',
      name: 'gywm',
      component: gywm
    },
    {
      path: '/qyjs',
      name: 'qyjs',
      component: qyjs
    },
    {
      path: '/test',
      name: 'test',
      component: test
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/my',
      name: 'my',
      component: my
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js